import store from '@/state/store'

const hasAccessAll = store.getters['identity/hasAccessAll']

const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

const getBaseFields = (t) => [
  {
    name: 'productName',
    label: translate(t, 'delivery.loadsTable.fields.productName', 'Nama Produk'),
    key: 'product.name',
    thStyle: 'max-width: 300px',
    rowspan: 2,
    headerTitle: true,
  },
  {
    name: 'product_category',
    label: translate(t, 'delivery.fields.productCategory', 'Kategori Produk'),
    key: 'product.product_type.product_category.name',
    thStyle: 'max-width: 300px',
    rowspan: 2,
    headerTitle: true,
  },
]

const getPlanFields = (t) => [
  {
    name: 'plan_group',
    key: 'plan_group',
    label: translate(t, 'delivery.loadsTable.fields.plan', 'Rencana'),
    colspan: 2,
    thClass: 'text-center',
    isParentHeader: true,
  },
  {
    name: 'quantityPlan',
    key: 'quantity',
    label: translate(t, 'delivery.loadsTable.fields.quantity', 'Kuantitas'),
    thStyle: 'width: 100px',
    thClass: 'text-center',
    isChildHeader: true,
    parentKey: 'plan_group',
  },
  {
    name: 'weightVolumePlan',
    key: 'total_weight',
    label: translate(t, 'delivery.loadsTable.fields.weightAndVolume', 'Berat dan Volume'),
    thStyle: 'width: 200px',
    thClass: 'text-center',
    isChildHeader: true,
    parentKey: 'plan_group',
  },
]

const getAdjustmentFields = (t) => [
  {
    name: 'aktual_group',
    key: 'aktual_group',
    label: translate(t, 'delivery.loadsTable.fields.actualPickup', 'Aktual Pengambilan'),
    colspan: 3,
    thClass: 'text-center',
    isParentHeader: true,
  },
  {
    name: 'quantityActual',
    key: 'quantity_picked',
    label: translate(t, 'delivery.loadsTable.fields.quantity', 'Kuantitas'),
    thStyle: 'width: 100px',
    thClass: 'text-center',
    isChildHeader: true,
    parentKey: 'aktual_group',
  },
  {
    name: 'weightVolumeActual',
    key: 'weight_picked',
    label: translate(t, 'delivery.loadsTable.fields.weightAndVolume', 'Berat dan Volume'),
    thStyle: 'width: 200px',
    thClass: 'text-center',
    isChildHeader: true,
    parentKey: 'aktual_group',
  },
  {
    name: 'reason',
    key: 'adjustment_reason_picked',
    label: translate(t, 'delivery.loadsTable.fields.changeReason', 'Alasan Perubahan'),
    thStyle: 'max-width: 200px',
    thClass: 'text-center',
    isChildHeader: true,
    parentKey: 'aktual_group',
  },
  {
    name: 'send_actual',
    key: 'send_actual',
    label: translate(t, 'delivery.loadsTable.fields.actualDelivered', 'Aktual Terkirim'),
    colspan: 3,
    thClass: 'text-center',
    isParentHeader: true,
    onlyForStatus: ['Terkirim'],
  },
  {
    name: 'quantitySend',
    key: 'quantity_delivered',
    label: translate(t, 'delivery.loadsTable.fields.quantity', 'Kuantitas'),
    thStyle: 'width: 200px',
    isChildHeader: true,
    parentKey: 'send_actual',
    onlyForStatus: ['Terkirim'],
  },
  {
    name: 'weightVolumeSend',
    key: 'weight_delivered',
    label: translate(t, 'delivery.loadsTable.fields.weightAndVolume', 'Berat dan Volume'),
    thStyle: 'width: 200px',
    isChildHeader: true,
    parentKey: 'send_actual',
    onlyForStatus: ['Terkirim'],
  },
  {
    name: 'reasonSend',
    key: 'adjustment_reason_delivered',
    label: translate(t, 'delivery.loadsTable.fields.changeReason', 'Alasan Perubahan'),
    thStyle: 'max-width: 200px',
    isChildHeader: true,
    parentKey: 'send_actual',
    onlyForStatus: ['Terkirim'],
  },
]

const getTemperatureField = (t) => [
  {
    name: 'minTemperature',
    label: translate(t, 'delivery.fields.minTemperature', 'Min. Temperatur'),
    key: 'min_temperature',
    formatter: (value) =>
      (value.min_temperature ?? '') === '' ? '-' : `${value.min_temperature} °C`,
    thStyle: 'width: 200px',
    rowspan: 2,
    headerTitle: true,
  },
  {
    name: 'maxTemperature',
    label: translate(t, 'delivery.fields.maxTemperature', 'Max. Temperatur'),
    key: 'max_temperature',
    formatter: (value) =>
      (value.max_temperature ?? '') === '' ? '-' : `${value.max_temperature} °C`,
    thStyle: 'width: 200px',
    rowspan: 2,
    headerTitle: true,
  },
]

const getNoteField = (t) => [
  {
    name: 'note',
    key: 'note',
    label: translate(t, 'delivery.loadsTable.fields.notes', 'Catatan'),
    thStyle: 'width: 200px',
    rowspan: 2,
    headerTitle: true,
  },
]

const getLoadFieldsSend = (t) => {
  let loadFieldsSend = [...getBaseFields(t), ...getPlanFields(t)]

  const hasLoadAdjustment = hasAccessAll(
    'delivery-load-adjustment:read',
    'delivery-load-adjustment:update'
  )
  const hasColdChain = hasAccessAll('tms-cold-chain:read')

  if (hasLoadAdjustment) {
    loadFieldsSend = [...loadFieldsSend, ...getAdjustmentFields(t)]
  }

  if (hasColdChain) {
    loadFieldsSend = [...loadFieldsSend, ...getTemperatureField(t)]
  } else {
    loadFieldsSend = [...loadFieldsSend]
  }

  loadFieldsSend = [...loadFieldsSend, ...getNoteField(t)]

  return loadFieldsSend
}

export default getLoadFieldsSend
